import React from "react";

export default function Seven({ fill, children }) {
  return (
    <svg
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <path d="M71.6,252.26h5.84a1.63,1.63,0,0,0,1.63-1.63A1.69,1.69,0,0,0,77.44,249H71.69A1.65,1.65,0,0,0,70,250.63,1.62,1.62,0,0,0,71.6,252.26Z" />
      <path d="M74.52,278.78a2.31,2.31,0,0,0-2.32,2.31,2.32,2.32,0,1,0,2.32-2.31Z" />
      <polygon points="65.94 277.32 83.01 277.32 83.01 254.66 65.94 254.49 65.94 277.32" />
      <path d="M258,1.51H42.1A11.9,11.9,0,0,0,30.26,13.26V287.15A11.78,11.78,0,0,0,42,298.91H258a11.77,11.77,0,0,0,11.75-11.76V13.26A11.77,11.77,0,0,0,258,1.51ZM85.67,261.61v19.74a3.54,3.54,0,0,1-3.51,3.52H67a3.53,3.53,0,0,1-3.52-3.52V250.46A3.54,3.54,0,0,1,67,246.94H82.16a3.59,3.59,0,0,1,3.51,3.52Zm175.06-36a6.33,6.33,0,0,1-6.35,6.35H45.7a6.34,6.34,0,0,1-6.35-6.35V16.86a6.35,6.35,0,0,1,6.35-6.35H254.38a6.34,6.34,0,0,1,6.35,6.35Z" />
      {children}
    </svg>
  );
}
